import LayoutManager from "./LayoutManager";
import ResponsiveProperty from "../data/ResponsiveProperty";

const $ = jQuery

interface GridLayoutManagerOptions {
    columns: ResponsiveProperty,
    columnGap: number,
    rowGap: number
}

class GridLayoutManager extends LayoutManager {

    private itemHeight = 0
    private itemWidth = 0
    private currentColumns = -1
    
    options: GridLayoutManagerOptions

    constructor(itemGrid: JQuery) {
        super(itemGrid)
        this.options = itemGrid.data('options')
        this.measureGrid()
        $(window).on('resize', () => {
            this.measureGrid()
        })
    }

    addItem(itemView: JQuery) {
        itemView.css('opacity', '0')
        itemView.css('transition', 'opacity 500ms')
        itemView.addClass('appearing')
        itemView.addClass('absolute')
        this.itemGrid.append(itemView)
    }

    layoutItem(itemView: JQuery, position: number = null) {

        if (position === null) {
            position = itemView.data('position')
        } else {
            itemView.data('position', position)
        }

        if (this.currentColumns == -1) this.measureGrid()
        if (this.itemHeight === 0) {
            itemView.css('width', `${this.itemWidth}px`)
            this.itemHeight = itemView.height()
        }
        
        const cols = this.currentColumns
        const colGap = this.options.columnGap
        const rowGap = this.options.rowGap
        const height = this.itemHeight
        const width = this.itemWidth
        const row = Math.floor((position) / cols)
        const col = ((position) % cols)
        const top = row * (height + rowGap)
        const left = col * (width + colGap)
        const visible = this.isOrWillBeVisible(itemView, top)
        if (visible) {
            if (!itemView.hasClass('appearing') && !itemView.hasClass('disappearing')) {
                itemView.css('transition', 'top 500ms, left 500ms')
            }
        } else {
            itemView.css('transition', '')
        }
        if (itemView.hasClass('appearing')) {
            itemView.css('opacity', '1')
            setTimeout(() => itemView.removeClass('appearing'), 500)
        }
        itemView.css('left', `${left}px`)
        itemView.css('top', `${top}px`)
        itemView.css('width', `${width}px`)
        itemView.css('height', `${height}px`)
    }

    private measureGrid() {
        const windowWidth = $(window).width()
  
        const columns = this.options.columns
        const colGap = this.options.columnGap
        let cols = 0
    
        if (windowWidth >= columns.desktop.breakpoint) cols = columns.desktop.value
        else if (windowWidth >= columns.tablet.breakpoint) cols = columns.tablet.value
        else cols = columns.mobile.value
        
        this.currentColumns = cols
    
        const itemWidth = (this.itemGrid.width() - (colGap * (cols - 1))) / cols
        let itemHeight = this.itemHeight
        if (this.itemGrid.children().length) {
            this.itemGrid.children().each((_, it) => {
                $(it).css('width', `${itemWidth}px`)
            })
            const itemHeights = this.itemGrid.find('.grid-item:not(.disappearing)').map((_, it) => $(it).find('.grid-item-content-wrapper').height()).get()
            itemHeight = Math.max(...itemHeights)
            this.itemHeight = itemHeight
            this.itemGrid.children().each((_, it) => {
                this.layoutItem($(it))
            })
        } else {
            this.itemHeight = 0
        }
        this.itemWidth = itemWidth
    
        this.updateGridDimensions()
    }

    private updateGridDimensions() {
        const visibleItems = this.visibleItems
        const cols = this.currentColumns
        const rowGap = this.options.rowGap
        const itemHeight = this.itemHeight
        
        const rows = Math.ceil(visibleItems / cols)
        
        const height = rows * itemHeight + (rows - 1) * rowGap
        this.itemGrid.css('min-height', `${Math.max(height, 56)}px`)
    }

    removeItem(itemView: JQuery) {
        if(!this.isOrWillBeVisible(itemView, Number.MAX_VALUE)) {
            itemView.remove()
            return
        }
        //Change ID so it won't be reused when the filter is changing again
        itemView.attr('id', `${itemView.attr('id')}-disappearing`)
        itemView.addClass('disappearing')
        itemView.css('transition', 'opacity 500ms')
        itemView.css('opacity', '0')
        setTimeout(() => itemView.remove(), 500)
    }

    private isOrWillBeVisible(view: JQuery, newTop: number) {
        const newBottom = view.height()
      
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();
        if (newBottom > viewportTop || newTop < viewportBottom) return true
      
        const position = view.position()
      
        if (position == null) return false
      
        const top = position.top
        const bottom = top + view.height()
        if (bottom > viewportTop || top < viewportBottom) return true
        return false
    }

    onMidUpdate() {
        this.measureGrid()
    }

    onPostUpdate() {
        this.measureGrid()
    }

}

export default GridLayoutManager